import { PathContext } from "../providers/PathProvider"
import { useContext } from "react"

const usePath = (): string | undefined => {
  return useContext(PathContext)
}

export default usePath
